// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { NgxLoggerLevel } from 'ngx-logger';
import { Environment } from '../app/model/environement';

export const environment: Environment = {
  production: false,
  //apiBasePath: 'http://localhost:8080',
  apiBasePath: 'https://app.exatrek.de',
  // apiBasePath: 'https://qs.exatrek.de',
  logLevel: NgxLoggerLevel.DEBUG,
  refreshTokenTime: 7 * 60 * 60 * 1000,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
